<script lang="ts" setup>
import 'vue-sonner/style.css'
import { RouterView, useRoute } from 'vue-router'
import { computed } from 'vue'
import { useAuth } from '@/modules/auth'
import { PwaInstallPrompt, PwaUpdateNotification } from '@/modules/pwa'
import AppNavigation from '@/components/AppNavigation.vue'
import MobileBottomNav from '@/components/MobileBottomNav.vue'
import AppSidebar from '@/components/AppSidebar.vue'
import SidebarMobileToggle from '@/components/SidebarMobileToggle.vue'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import { Toaster } from '@/components/ui'

const auth = useAuth()
const route = useRoute()

const isAdminSection = computed(() => route.path.startsWith('/admin'))
</script>

<template>
  <div id="app" class="bg-background flex flex-col h-screen">
    <AppNavigation />

    <template v-if="isAdminSection && auth.isAdmin">
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset>
          <main class="flex-1 flex flex-col gap-4 overflow-y-auto p-4">
            <SidebarMobileToggle />
            <RouterView />
          </main>
        </SidebarInset>
      </SidebarProvider>
    </template>

    <template v-else>
      <main class="flex-1 container mx-auto p-6 pb-20 sm:pb-6">
        <RouterView />
      </main>
    </template>

    <MobileBottomNav />
    <PwaInstallPrompt />
    <PwaUpdateNotification />
    <Toaster />
  </div>
</template>
